import { render, staticRenderFns } from "./TeacherPaymentInputPage.vue?vue&type=template&id=0ecfb86e&"
import script from "./TeacherPaymentInputPage.vue?vue&type=script&lang=ts&"
export * from "./TeacherPaymentInputPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports